import action from "../../actionTypes";

export const bookingModalsDefaultState = {
  bookingErrorModal: {
    isVisible: false,
    candidateObjectId: null
  },
  CTAModal: {
    isVisible: false,
    modalHeader: "",
    CandidateObjectId: null,
    BookingObjectId: null,
    Status: null,
    errorMsg: null,
    personObjectId: null,
    actionBtnName: null,
    details: {},
    bookingCTA: false
  },
  addBookingModal: {
    isVisible: false,
    bookingData: {}
  },
  detailPlaningModal: {
    isVisible: false
  },
  clientValidationModal: {
    isVisible: false,
    failedBookings: null
  },
  bookingDetailsModal: {
    isVisible: false,
    bookingId: null,
    candidateName: null,
    zIndex: null
  },
  importBookingModal: {
    isVisible: false
  },
  importBookingValidationModal: {
    isVisible: false,
    errors: null
  },
  importBookingDocumentModal: {
    isVisible: false
  }
};

const initialState = {
  bookingErrorModal: bookingModalsDefaultState.bookingErrorModal,
  addBookingModal: bookingModalsDefaultState.addBookingModal,
  detailPlaningModal: bookingModalsDefaultState.detailPlaningModal,
  clientValidationModal: bookingModalsDefaultState.clientValidationModal,
  bookingDetailsModal: bookingModalsDefaultState.bookingDetailsModal,
  CTAModal: bookingModalsDefaultState.CTAModal,
  importBookingModal: bookingModalsDefaultState.importBookingModal,
  importBookingValidationModal: bookingModalsDefaultState.importBookingValidationModal,
  importBookingDocumentModal: bookingModalsDefaultState.importBookingDocumentModal
};

const bookingModalsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case action.BOOKING_ERROR_MODAL:
      return { ...state, bookingErrorModal: payload };
    case action.ADD_BOOKING_MODAL:
      return { ...state, addBookingModal: payload };
    case action.DETAIL_PLANING_MODAL:
      return { ...state, detailPlaningModal: payload };
    case action.CLIENT_VALIDATION_MODAL:
      return { ...state, clientValidationModal: payload };
    case action.BOOKING_DETAILS_MODAL:
      return { ...state, bookingDetailsModal: payload };
    case action.CTA_MODAL:
      return { ...state, CTAModal: payload };
    case action.IMPORT_BOOKING_MODAL:
      return { ...state, importBookingModal: payload };
    case action.IMPORT_BOOKING_VALIDATION_MODAL:
      return { ...state, importBookingValidationModal: payload };
    case action.IMPORT_BOOKING_DOCUMENT_MODAL:
      return { ...state, importBookingDocumentModal: payload };
    default:
      return state;
  }
};

export default bookingModalsReducer;
